import React, { useState, useEffect } from 'react';
import {
  Button,
  Card,
  FormControlLabel,
  CardContent,
  Backdrop,
  Grid,
  Typography,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Switch,
} from '@mui/material';
import { LoadingPage } from 'components';
import { versionService, serviceCallListApi } from '../../services/WebServiceServices';
import SimpleDialog from './SimpleDialog';
import { useStyles } from '../Style';

const VersionService = (props) => {
  const classes = useStyles();
  const [list, setList] = useState([]);
  const [openDialog, setOpenDialog] = React.useState(false);
  const [selectedValue, setSelectedValue] = React.useState('');
  const [loading, setLoading] = React.useState(true);
  const [status, setStatus] = React.useState({});
  const [open, setOpen] = React.useState(true);

  useEffect(() => {
    (async () => {
      try {
        const dataService = { offset: 0, size: 10, showDisable: false };
        const resData = await serviceCallListApi(dataService);
        const dataVersionSer = resData.result.filter(
          (rowData) => rowData.dataServiceCall.id == props.match.params.id,
        );
        const dataSerCall = [dataVersionSer[0].dataServiceCall];

        // setDataVerService(dataVersionSer);
        const params = { offset: 0, size: 10, id: props.match.params.id };
        const data = await versionService(params);
        const corectDataVersionList = data.result.map((row) => {
          const data = JSON.parse(row.metadata, null, 5);
          row.metadata = '';
          row.scProvider = data.scProvider;
          row.scInputParams = data.scInputParams;
          row.scHeaderParams = data.scHeaderParams;
          row.scAutoApprove = data.scAutoApprove;
          row.scClientId = data.scClientId;
          row.scEnName = data.scEnName;
          row.scFaName = data.scFaName;
          row.scGuildCode = data.scGuildCode;
          row.scHttpVerb = data.scHttpVerb;
          row.scInquiryHttpVerb = data.scInquiryHttpVerb;
          row.scNamespace = data.scNamespace;
          row.scPaymentType = data.scPaymentType;
          row.scPriceCalculationType = data.scPriceCalculationType;
          row.scPriceHeader = data.scPriceHeader;
          row.scPriceInquiryUrl = data.scPriceInquiryUrl;
          row.scSelfClose = data.scSelfClose;
          row.scStakeholderList = data.scStakeholderList;
          row.scSuccessfulResult = data.scSuccessfulResult;
          row.scType = data.scType;
          row.scUrl = data.scUrl;
          return row;
        });

        const totalVersion = dataSerCall.concat(corectDataVersionList);

        setList(totalVersion);
        let sw = {};
        data.result.forEach((d, index) => {
          const n = `switch${index}`;
          sw = { ...sw, [n]: d.enable };
        });
        setStatus(sw);

        setLoading(false);
      } catch (error) {
        console.log('error:', error);
      }
    })();
  }, []);

  const handleOpenDialog = (index) => {
    const meta = {
      scAutoApprove: index.scAutoApprove,
      scClientId: index.scClientId,
      scEnName: index.scEnName,
      scFaName: index.scFaName,
      scGuildCode: index.indexscGuildCode,
      scHttpVerb: index.scHttpVerb,
      scInquiryHttpVerb: index.scInquiryHttpVerb,
      scNamespace: index.scNamespace,
      scPaymentType: index.scPaymentType,
      scPriceCalculationType: index.scPriceCalculationType,
      scPriceHeader: index.scPriceHeader,
      scPriceInquiryUrl: index.scPriceInquiryUrl,
      scProvider: index.scProvider,
      scSelfClose: index.scSelfClose,
      scType: index.scType,
      scUrl: index.scUrl,
      scSuccessfulResult: {
        scHttpStatusCode:
          index.scSuccessfulResult?.scHttpStatusCode && index.scSuccessfulResult.scHttpStatusCode,
        scHttpResponse:
          index.scSuccessfulResult?.scHttpResponse && index.scSuccessfulResult.scHttpResponse,
      },
      scStakeholderList: index.scStakeholderList,
      scHeaderParams: [
        index.scHeaderParams?.map((row) => ({
          scParameterName: row.scParameterName,
          scParameterDesc: row.scParameterDesc,
          scParameterDefaultValue: row.scParameterDefaultValue,
          scSelfClose: row.scSelfClose,
        })),
      ],
    };
    const dataJson = JSON.stringify(meta, null, 5);
    setSelectedValue(dataJson);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    (async () => {
      try {
        const dataServiceCall = {
          enable: status,
        };
    
      } catch (error) {
        console.log('error:', error);
      }
    })();
  }, [status]);

  return (
    <>
      {loading ? (
        <Backdrop className={classes.backdrop} open={open} onClick={handleClose}>
          <LoadingPage />
        </Backdrop>
      ) : (
        <>
          <Card className={classes.root}>
            <CardContent>
              <Grid container className={classes.detailsPage}>
                <Grid item xs={12}>
                  <Typography className={classes.title} color="textSecondary" gutterBottom>
                    لیست نسخه های سرویس
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <TableContainer component={Paper}>
                    <Table stickyHeader>
                      <TableHead>
                        <TableRow>
                          <TableCell>شماره نسخه</TableCell>
                          <TableCell>جزییات سرویس</TableCell>
                          <TableCell align="center">وضعیت</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {list.length > 0 ? (
                          list.map((row, index) => {
                            return (
                              <TableRow key={row.id}>
                                <TableCell>{row.serviceVersion}</TableCell>
                                <TableCell>
                                  <Button onClick={() => handleOpenDialog(row)}>نمایش</Button>
                                </TableCell>
                                <TableCell align="center">
                                  <FormControlLabel
                                    control={
                                      <Switch
                                        size="small"
                                        defaultChecked
                                        checked={
                                          status[`switch${index}`]
                                            ? status[`switch${index}`]
                                            : false
                                        }
                                        onChange={(event) => {
                                          const newcheked = `switch${index}`;
                                          setStatus({
                                            ...status,
                                            [newcheked]: event.target.checked,
                                          });
                                        }}
                                        name={`switch${index}`}
                                        inputProps={{
                                          'aria-label': 'secondary checkbox',
                                        }}
                                        className='iosSwitch'
                                      />
                                    }
                                    label={status[`switch${index}`] ? 'فعال' : 'غیر فعال'}
                                  />
                                </TableCell>
                              </TableRow>
                            );
                          })
                        ) : (
                          <TableRow>
                            <TableCell align="center" colSpan={7}>
                              داده موجود نیست.
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
          <SimpleDialog
            selectedValue={selectedValue}
            open={openDialog}
            onClose={handleCloseDialog}
          />
        </>
      )}
    </>
  );
};

export default VersionService;
